import Event from '../../core/Event';
import { ArticleOrderDraft, ItemValidationResult } from '../../../domain/Order';

export default class OrderImportSucceed extends Event {
    public static type = 'OrderImportSucceed';

    constructor(public readonly orders: ArticleOrderDraft[], public readonly itemValidationResult: ItemValidationResult[]) {
        super(OrderImportSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderImportSucceed.ts